"use client";
import React, { useRef, useEffect } from "react";

const testimonials = [
  {
    quote: "Her readings are incredibly accurate and helped me gain clarity.",
    name: "Priya S.",
  },
  {
    quote: "I felt a real shift after the session. Highly recommended.",
    name: "Neha K.",
  },
  {
    quote: "Very calming and insightful experience.",
    name: "Riya M.",
  },
];

const TestimonialsSection: React.FC = () => {
  const cardsRef = useRef<(HTMLDivElement | null)[]>([]);
  const parallaxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove("card-hidden");
            entry.target.classList.add("card-reveal");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    cardsRef.current.forEach((card) => {
      if (card) {
        card.classList.add("card-hidden");
        observer.observe(card);
      }
    });

    let rafId: number;
    const handleParallax = () => {
      if (!parallaxRef.current) return;
      const rect = parallaxRef.current.getBoundingClientRect();
      const offset = rect.top * 0.4;
      parallaxRef.current.style.transform = `translateY(${offset * 0.08}px)`;
      rafId = requestAnimationFrame(handleParallax);
    };
    rafId = requestAnimationFrame(handleParallax);

    return () => {
      observer.disconnect();
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <section id="testimonials" className="relative py-20 md:py-28 px-6 bg-secondary/40">
      <div ref={parallaxRef} className="max-w-5xl mx-auto" style={{ willChange: "transform" }}>
        <div className="text-center mb-14">
          <span className="section-label">Kind Words</span>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-foreground mt-4">
            Testimonials
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              ref={(el) => { cardsRef.current[i] = el; }}
              className="testimonial-card p-8 flex flex-col gap-4"
            >
              <span className="text-accent text-3xl font-display">&ldquo;</span>
              <p className="text-foreground-muted text-sm font-body leading-relaxed italic">
                {t.quote}
              </p>
              <p className="text-foreground font-semibold text-sm mt-auto font-body">
                — {t.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
